import { render, staticRenderFns } from "./HistoryDocument.vue?vue&type=template&id=47f8c08e&scoped=true"
import script from "./HistoryDocument.vue?vue&type=script&lang=js"
export * from "./HistoryDocument.vue?vue&type=script&lang=js"
import style0 from "./HistoryDocument.vue?vue&type=style&index=0&id=47f8c08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8c08e",
  null
  
)

export default component.exports